import { render, staticRenderFns } from "./CandidatesList.vue?vue&type=template&id=4a0e690f&"
import script from "./CandidatesList.vue?vue&type=script&lang=js&"
export * from "./CandidatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports